/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState, useMemo, useEffect,
} from "react";

import ScheduleSelection from "./Steps/ScheduleSelection";
import AppointmentForm from "./Steps/AppointmentForm";

import { translate } from "../i18n";
import WizardContext from "./Steps/context/WizardContext";

/**
 * Componente de navegación.
 *
 * @returns Componente de navegación.
 */
function MultiStepNav() {

  // ======================
  // Estados del componente
  // ======================

  const [step, setStep] = useState(0);
  const [extraInfo, setExtraInfo] = useState([]);
  const [localSlot, setLocalSlot] = useState({});
  const [persistentData, setPersistentData] = useState({});
  const [appointmentData, setAppointmentData] = useState({});

  // ========================
  // Memoizacion del contexto
  // ========================

  const context = useMemo(
    () => ({
      step,
      extraInfo,
      localSlot,
      appointmentData,
      persistentData,
      setStep,
      setExtraInfo,
      setLocalSlot,
      setAppointmentData,
      setPersistentData,
    }),
    [step, extraInfo, localSlot, appointmentData, persistentData, setStep, setExtraInfo,
      setLocalSlot, setAppointmentData, setPersistentData],
  );

  /**
   * Variable que define los pasos del asistente.
   */
  const steps = [
    {
      id: 1,
      name: (
        <span className={`font-weight-bold ${step === 0
          ? "text-primary font-weight-bold" : "text-primary-l6 font-weight-semi-bold"}`}
        >
          {translate("office-schedule")}
        </span>
      ),
      component: <ScheduleSelection />,
    },
    {
      id: 2,
      name: (
        <span className={`font-weight-bold ${step === 1
          ? "text-primary font-weight-bold" : "text-primary-l6 font-weight-semi-bold"}`}
        >
          {translate("appointment-data")}
        </span>
      ),
      component: <AppointmentForm />,
    },
  ];

  // ========================
  // Función de carga inicial
  // ========================

  useEffect(() => {

    setStep(0);

  }, []);

  // =======================
  // Template del componente
  // =======================

  return (

    <WizardContext.Provider value={context}>
      {steps[step].component}
    </WizardContext.Provider>

  );

}

export default MultiStepNav;
